module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.03.c-323f4271ac1217a29a5dffeb3378fbb9.svg";